import TrackOrderPill from 'components/track-order-pill';
import useDashboardContext from 'contexts/dashboard.context';
import React, { useEffect, useState } from 'react';
import db from 'utils/firebase-config';
import { OrderType } from 'models/order.model';
import Slider from 'react-slick';
import { useLocation } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const PillAlerts = () => {
  const [orders, setOrders] = useState<OrderType[]>([]);
  const { activeCompany } = useDashboardContext();
  const { pathname } = useLocation();
  const { calculatedOrder } = useDashboardContext();

  const getOrders = async () => {
    try {
      const snapshot = await db
        .collection('tracking_orders')
        .where('company_id', '==', activeCompany.id)
        .get();
      const fetchedData: OrderType[] = [];
      snapshot.forEach((doc) => {
        fetchedData.push({ id: doc.id, ...doc.data() } as OrderType);
      });
      setOrders(fetchedData);
    } catch (error) {
      console.error('Error getting document:', error);
    }
  };
  useEffect(() => {
    getOrders();
  }, []);

  const inTransitOrders = orders.filter(
    ({ kitchen_dispatched, rider_assigned, completed, cancelled }) =>
      kitchen_dispatched && rider_assigned && !completed && !cancelled
  );

  const settings = {
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    pauseOnFocus: true,
    pauseOnHover: true
  };

  const isOrdersPage =
    pathname.split('/').length === 2 && pathname.split('/')[1] === ROUTE_KEYS.ORDERS;
  return (
    <div className='w-11/12 md:max-w-[620px] fixed bottom-5 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
      <Slider {...settings} className='bg-transparent'>
        {inTransitOrders.length > 0 &&
          inTransitOrders.map((order) => (
            <div className='h-[70px]' key={order.order_code}>
              <TrackOrderPill type='ONGOING' order={order} />
            </div>
          ))}
        {isOrdersPage &&
          calculatedOrder?.meals?.length > 0 &&
          calculatedOrder?.total_amount > 0 &&
          (calculatedOrder.is_group_order && calculatedOrder.group_cancelled ? null : (
            <div className='h-[70px]'>
              <TrackOrderPill type='INCOMPLETE' is_group_order={calculatedOrder?.is_group_order} />
            </div>
          ))}
      </Slider>
    </div>
  );
};

export default PillAlerts;
